import type { ApiClient, Appointment, ChangeRequest } from "@shyne/shared/api";
import type { uuid } from "@/interfaces";
import type { appointment_status } from "@/models/appointment.model";
import { CANCELLABLE_STATUSES } from "./appointment-cancellation";
import { calendarDay } from "./appointment-reschedule";

export const SERVICE_CHANGEABLE_STATUSES: readonly appointment_status[] = CANCELLABLE_STATUSES;

export const isChangeableDay = (day: Date, currentDate: string): boolean => calendarDay(day) !== currentDate;

type ChangeApi = Pick<ApiClient["appointments"], "change">;

export type AppointmentChanges = Omit<ChangeRequest, "actingOrganization">;

export function createAppointmentChange(api: ChangeApi) {
  return function change(id: uuid, changes: AppointmentChanges, actingOrganization: uuid | null): Promise<Appointment> {
    return api.change(id, { ...changes, ...(actingOrganization ? { actingOrganization } : {}) });
  };
}
